<template>
  <div>
    <div class="row">
      <div class="col-sm-6">
        <card style="background-color: #eeeeee; border: 5px outset">
          <form class="form-horizontal">
            <h3 slot="header" class="text-center">Order Summary</h3>
            <div class="row">
              <label class="col-md-6 col-form-label">Site:</label>
              <div class="col-md-6">
                <input
                  type="text"
                  readonly
                  class="form-control-plaintext"
                  id="siteNameSummary"
                  :value="siteName"
                />
              </div>

              <label class="col-md-6 col-form-label">Station:</label>
              <div class="col-md-6">
                <input
                  type="text"
                  readonly
                  class="form-control-plaintext"
                  id="stationNameSummary"
                  :value="statioName"
                />
              </div>

              <label class="col-md-6 col-form-label">Connection:</label>
              <div class="col-md-6">
                <input
                  type="text"
                  readonly
                  class="form-control-plaintext"
                  id="connectionNameSummary"
                  :value="connectionName"
                />
              </div>

              <label class="col-md-6 col-form-label">Hours Reserved:</label>
              <div class="col-md-6">
                <input
                  type="text"
                  readonly
                  class="form-control-plaintext"
                  id="hoursReservedPaymentDet"
                  :value="summary.inputHours"
                />
              </div>
              <label class="col-md-6 col-form-label">Cost/Hour:</label>

              <div class="col-md-6">
                <input
                  type="text"
                  readonly
                  class="form-control-plaintext"
                  id="costPerHourPaymentDet"
                  :value="costPerHour"
                />
              </div>

              <label class="col-md-6 col-form-label">Start up Cost:</label>
              <div class="col-md-6">
                <input
                  type="text"
                  readonly
                  class="form-control-plaintext"
                  id="startupCost"
                  :value="startupCost"
                />
              </div>

              <label class="col-md-6 col-form-label">Discount:</label>
              <div class="col-md-6">
                <input
                  type="text"
                  readonly
                  class="form-control-plaintext"
                  id="discount"
                  :value="totalDiscount"
                />
              </div>

              <label class="col-md-6 col-form-label">Total Cost:</label>
              <div class="col-md-6">
                <input
                  type="text"
                  readonly
                  class="form-control-plaintext"
                  id="totalCostSummary"
                  :value="totalCostFormatted"
                />
              </div>
              <label class="col-md-6 col-form-label">Estimated End Time:</label>
              <div class="col-md-6">
                <input
                  type="text"
                  readonly
                  class="form-control-plaintext"
                  id="newEndTimeSummary"
                  :value="newEndTime"
                />
              </div>
            </div>
          </form>
        </card>
      </div>

      <div class="col-sm-6">
        <card style="background-color: #eeee; border: 5px outset">
          <h3
            slot="header"
            class="header text-center"
            style="margin-bottom: 0px"
          >
            Payment Details
          </h3>
          <div class="row mb-3">
            <div class="col-sm-2 text-center">
              <i class="fab fa-cc-visa fa-2x"></i>
            </div>
            <div class="col-sm-2 text-center">
              <i class="fab fa-cc-mastercard fa-2x"></i>
            </div>
            <div class="col-sm-2 text-center">
              <i class="fab fa-cc-amex fa-2x"></i>
            </div>
            <div class="col-sm-2 text-center">
              <i class="fab fa-cc-jcb fa-2x"></i>
            </div>
            <div class="col-sm-2 text-center">
              <i class="fab fa-cc-discover fa-2x"></i>
            </div>
            <div class="col-sm-2 text-center">
              <i class="fab fa-cc-diners-club fa-2x"></i>
            </div>
          </div>
          <div id="form-container">
            <div id="sq-ccbox">
              <form>
                <div id="card-container"></div>
                <div v-if="isCardInitialized">
                  <button
                    v-show="totalCostWithDiscount > 0"
                    :disabled="paymentDisabled"
                    class="button-credit-card"
                    type="button"
                    @click="makePayment($event)"
                  >
                    Pay {{ totalCostFormatted }}
                  </button>
                  <button
                    v-show="totalCostWithDiscount == 0"
                    id="free-charge-button"
                    class="button-credit-card"
                    @click="freeBooking()"
                  >
                    Free
                  </button>
                </div>
                <div class="loading" v-else-if="!isCardInitialized">
                  Loading ...
                </div>
              </form>
            </div>
            <!-- end #sq-ccbox -->
          </div>
          <!-- end #form-container -->
        </card>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <card style="background-color: #eeeeee; border: 5px outset">
          <form class="form-horizontal">
            <h3 slot="header" class="text-center">Discount</h3>
            <div class="row justify-content-center">
              <div class="form-group form-check-inline">
                <p-radio v-model="discountModel.discountType" label="percentage"
                  >Percentage</p-radio
                >
                <p-radio v-model="discountModel.discountType" label="fix"
                  >Fix Amount</p-radio
                >
              </div>
              <div class="form-group">
                <fg-input
                  class="col"
                  placeholder="Enter Fix Amount"
                  name="fix discount"
                  addon-right-icon="fas fa-dollar-sign"
                  v-show="discountModel.discountType == 'fix'"
                  type="number"
                  v-model="discountModel.discountVal"
                  step="1"
                  min="1"
                  v-validate="totalCostMax"
                  :error="getError('fix discount')"
                ></fg-input>
              </div>
              <div class="form-group">
                <fg-input
                  class="col"
                  placeholder="Enter Percentage"
                  name="percentage discount"
                  addon-right-icon="fas fa-percentage"
                  v-show="discountModel.discountType == 'percentage'"
                  type="number"
                  v-model="discountModel.discountVal"
                  step="1"
                  min="1"
                  v-validate="discountRules.percentageType"
                  :error="getError('percentage discount')"
                ></fg-input>
              </div>
            </div>
            <div class="row justify-content-center">
              <p-button type="success" @click="applyDiscount"
                >Apply Discount</p-button
              >
            </div>
          </form>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { InfoSection } from "src/components/UIComponents";
import { EventBus } from "src/util/event-bus.js";
import HTTP from "src/util/http-common.js";

export default {
  name: "payment-details",
  components: {
    InfoSection,
  },
  props: {
    summary: {
      type: Object,
      required: true,
    },
    isPaymentTab: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      appId: process.env.VUE_APP_SQUARE_APPLICATION_ID,
      locationId: process.env.VUE_APP_LOCATION_ID,
      card: null,
      isCardInitialized: false,
      paymentDisabled: false,
      paymentForm: null,
      newEndTime: "",
      discountModel: {
        discountType: null,
        discountVal: 0,
        totalDiscount: 0,
      },
      discountRules: {
        percentageType: {
          max_value: 100,
          required: true,
        },
      },
    };
  },
  beforeDestroy() {
    this.destroyCard();
  },
  computed: {
    totalCostMax() {
      return {
        max_value: this.totalCostWithoutDiscount,
      };
    },
    totalCostWithDiscount() {
      return (
        this.summary.inputHours * this.summary.costPerHour +
        this.summary.startUpCost -
        this.discountModel.totalDiscount
      );
    },
    totalCostWithoutDiscount() {
      return (
        this.summary.inputHours * this.summary.costPerHour +
        this.summary.startUpCost
      );
    },
    totalCostFormatted() {
      return this.currencyFormatter().format(this.totalCostWithDiscount);
    },
    startupCost() {
      return this.currencyFormatter().format(this.summary.startUpCost);
    },
    totalDiscount() {
      return this.currencyFormatter().format(this.discountModel.totalDiscount);
    },
    costPerHour() {
      return this.currencyFormatter().format(this.summary.costPerHour);
    },
    siteName() {
      if ("siteInformation" in this.summary) {
        return this.summary.siteInformation.name;
      } else {
        return "";
      }
    },
    statioName() {
      if ("siteInformation" in this.summary) {
        return this.summary.stationDetails.station_number;
      } else {
        return "";
      }
    },
    connectionName() {
      if ("siteInformation" in this.summary) {
        return this.summary.connectionDetails.connection_point;
      } else {
        return "";
      }
    },
  },
  watch: {
    isPaymentTab: function (newVal, oldVal) {
      if (newVal === false && this.card !== null) {
        this.destroyCard();
        this.discountModel.discountType = null;
        this.discountModel.discountVal = 0;
        this.discountModel.totalDiscount = 0;
      } else if (newVal === true && this.card === null) {
        this.getEstEndTime();
        this.loadCard();
      }
    },
  },
  methods: {
    async destroyCard() {
      await this.card.destroy();
      this.card = null;
      this.isCardInitialized = false;
      //this.paymentDisabled=true;
    },

    async loadCard() {
      this.card = null;
      const payments = Square.payments(this.appId, this.locationId);
      try {
        this.card = await payments.card();
        this.isCardInitialized = true;
        await this.card.attach("#card-container");
      } catch (e) {
        this.notifyVue("Initializing Card failed", e, "error");
        return;
      }
    },

    async onGetTokenizer() {
      const tokenResult = await this.card.tokenize();
      if (tokenResult.status === "OK") {
        return tokenResult.token;
      } else {
        let errorMessage = `${tokenResult.status} Card`;
        this.notifyVue("Tokenization failed", errorMessage, "error");
      }
    },

    async makePayment(event) {
      event.preventDefault();
      this.paymentDisabled = true;
      try {
        const token = await this.onGetTokenizer();
        if (token) {
          this.postBooking(token);
        }
      } catch (e) {
        this.notifyVue("Payment Failed", e, "error");
      }
      this.paymentDisabled = false;
    },

    getEstEndTime() {
      HTTP.get("api/v1/utils/end_time", {
        params: {
          hours_to_add: this.summary.inputHours,
          old_end_time: Math.floor(new Date().getTime() / 1000),
        },
      })
        .then((response) => {
          const utcDate = new Date(response.data).toUTCString();
          // Format the UTC date
          this.newEndTime = new Intl.DateTimeFormat("en-US", {
            timeZone: "UTC",
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            hour12: true,
          }).format(new Date(utcDate));
        })
        .catch((err) => {
          this.newEndTime = "Error calculating new End Time!!!";
        });
    },
    postBooking(nonce) {
      let loader = this.$loading.show();
      var params = {
        connection_id: this.summary.connectionDetails.id,
        input_hour: this.summary.inputHours,
        cost_per_hour: this.summary.costPerHour,
        startup_cost: this.summary.startUpCost,
        site_id: this.summary.siteInformation.id,
        discount_amount: parseInt(this.discountModel.totalDiscount),
      };
      if (nonce !== undefined) {
        params["nonce"] = nonce;
      }
      HTTP.post("api/v1/booking/", params)
        .then((response) => {
          this.$emit("next-tab", response.data);
          loader.hide();
        })
        .catch((err) => {
          loader.hide();
          this.$notify({
            group: "general",
            title: "Error creating booking",
            text: err.response.data.error,
            type: "error",
          });
        });
    },

    async applyDiscount() {
      if (this.discountModel.discountType == "fix") {
        var isValid = await this.$validator.validate("fix discount");
      } else if (this.discountModel.discountType == "percentage") {
        var isValid = await this.$validator.validate("percentage discount");
      }

      if (isValid) {
        if (this.discountModel.discountType == "fix") {
          this.discountModel.totalDiscount = this.discountModel.discountVal;
        } else if (this.discountModel.discountType == "percentage") {
          this.discountModel.totalDiscount =
            (this.totalCostWithoutDiscount * this.discountModel.discountVal) /
            100;
        }
      }
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    freeBooking() {
      event.preventDefault();
      this.postBooking();
    },
  },
};
</script>
<style scoped>
/*
  Copyright 2019 Square Inc.
  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at
      http://www.apache.org/licenses/LICENSE-2.0
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/

* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body,
html {
  background-color: #f7f8f9;
  color: #373f4a;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: normal;
  height: 100%;
}

button {
  border: 0;
  font-weight: 500;
}

fieldset {
  margin: 0;
  padding: 0;
  border: 0;
}

#form-container {
  position: relative;
  width: 100%;
  margin: 0 auto;
  top: 50%;
  /* transform: translateY(-50%); */
}

.third {
  float: left;
  width: calc((100% - 32px) / 3);
  padding: 0;
  margin: 0 16px 16px 0;
  /* background-color: #eeeeee; */
  border-radius: 20px;
}

.third:last-of-type {
  margin-right: 0;
}

/* Define how SqPaymentForm iframes should look */
/* .sq-input {
  height: 56px;
  box-sizing: border-box;
  border: 1px solid #E0E2E3;
  background-color: #eeee;
  border-radius: 6px;
  display: inline-block;
  -webkit-transition: border-color .2s ease-in-out;
     -moz-transition: border-color .2s ease-in-out;
      -ms-transition: border-color .2s ease-in-out;
          transition: border-color .2s ease-in-out;
} */

/* Define how SqPaymentForm iframes should look when they have focus */
.sq-input--focus {
  border: 1px solid #6e4eec;
}

/* Define how SqPaymentForm iframes should look when they contain invalid values */
.sq-input--error {
  border: 1px solid #e02f2f;
}

.errorbox {
  line-height: 14px;
  text-align: left;
}

.sq-card-number {
  margin-bottom: 16px;
}

/* Customize the "Pay with Credit Card" button */
.button-credit-card {
  border-radius: 50px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08), 0px 1px 3px rgba(0, 0, 0, 0.04);
  height: auto;
  font-size: 16px;
  letter-spacing: 0.5px;
  line-height: 24px;
  margin-top: 16px;
  padding: 16px;
  position: relative;
  text-transform: uppercase;
  width: 100%;
  z-index: 1;
  background: linear-gradient(180deg, #8e72ff -57.14%, #6e4eec 125%);
  border: none;
  color: #fff;
}

.button-credit-card:hover {
  background: linear-gradient(180deg, #a791ff -57.14%, #856aef 125%);
  color: #fff;
}
.loading {
  text-align: center;
  margin: 3%;
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>
